export default __webpack_public_path__ + "static/intro-video-720-hb-1mb-49d3e8fef6e68ba6a1b9016a9c4fe631.mp4";